// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".green_button{padding:.25rem .75rem}.v-data-table th{white-space:nowrap}", ""]);
// Exports
module.exports = exports;
